import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/add-to-portfolio.svg";
var AddToPortfolioOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  AddToPortfolioOutline_default as default
};
